import React from 'react';
import { CircularProgress, Typography } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

import { ICustomTheme } from 'interfaces';

/** Success screen — fallback text when no confirmationMessage is set */
export const StyledSuccessMessage = styled(Typography)(() => ({
  padding: '48px 0',
}));

/** Wrapper for the "answer again" button on the success screen */
export const StyledAnswerAgainWrapper = styled('div')(() => ({
  paddingBottom: '32px',
  display: 'flex',
  justifyContent: 'center',
}));

/** Inline submit-error notice below the questions */
export const StyledSubmitError = styled(Typography)(() => ({
  marginTop: 16,
}));

/** Visually-hidden submit button triggered programmatically by QuizNavigation */
export const StyledHiddenSubmitButton = styled('button')(() => ({
  display: 'none',
}));

/**
 * Loader displayed inside the round validation button while the entry is sent.
 * Coloured with the BO palette (like the FO `CustomButton` loader) and not in
 * white: MUI greys out the background of a disabled `contained` button, so a
 * white spinner would be invisible while the submission is in flight.
 */
export const StyledSubmitLoader = styled(CircularProgress)(
  ({ theme }: { theme: ICustomTheme }) => ({
    color: theme.colors.paletteFromBO.main,
  }),
);

/** Required-field asterisk (*) coloured with the BO primary colour */
export const StyledRequiredAsterisk = styled('span')(
  ({ theme }: { theme: ICustomTheme }) => ({
    color: theme.colors.paletteFromBO.main,
    marginLeft: 2,
  }),
);

/** Required-field caption below a question */
export const StyledRequiredCaption = styled(Typography)(() => ({
  display: 'block',
  marginTop: 16,
}));

const StepPanelBase = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & { visible?: boolean }
>(({ visible: _visible, ...rest }, ref) =>
  React.createElement('div', { ref, ...rest }),
);

/**
 * Wrapper for each step's questions.
 * All steps stay mounted (so RHF keeps values); only the active one is shown.
 */
export const StyledStepPanel = styled(StepPanelBase)(
  ({ visible }: { visible?: boolean }) => ({
    display: visible ? 'block' : 'none',
  }),
);
